/** Say a name aloud with the browser's own speech engine (British English where available). */

function levenshtein(a: string, b: string): number {
  const dp = Array.from({ length: b.length + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i++) {
    let prev = dp[0];
    dp[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const tmp = dp[j];
      dp[j] = Math.min(dp[j] + 1, dp[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = tmp;
    }
  }
  return dp[b.length];
}

export function canSpeak(): boolean {
  return typeof window !== "undefined" && "speechSynthesis" in window && typeof SpeechSynthesisUtterance !== "undefined";
}

/** Text to hand the speech engine: the name itself, or its respelling when the spelling would mislead. */
export function speechText(name: string, pron?: string): string {
  if (!pron) return name;
  const plain = pron.toLowerCase().replace(/[^a-z]/g, "");
  const spelled = name.toLowerCase().replace(/[^a-z]/g, "");
  const far = levenshtein(plain, spelled) / Math.max(plain.length, spelled.length) > 0.5;
  return far ? pron.toLowerCase().replace(/-/g, "") : name;
}

export function speak(name: string, pron?: string): void {
  if (!canSpeak()) return;
  const synth = window.speechSynthesis;
  synth.cancel();
  const u = new SpeechSynthesisUtterance(speechText(name, pron));
  const voices = synth.getVoices();
  const gb = voices.find((v) => v.lang === "en-GB" && /female|serena|kate|libby|sonia/i.test(v.name)) ?? voices.find((v) => v.lang === "en-GB");
  if (gb) u.voice = gb;
  u.lang = "en-GB";
  u.rate = 0.85;
  synth.speak(u);
}
